import React from 'react';
import Logo from '../Logo';
import data from '../logos/simplified-chinese-eng';

const LogoSimplifiedChineseEng = (props) => <Logo {...props} data={data} />;

LogoSimplifiedChineseEng.displayName = 'LogoSimplifiedChineseEng';

export default LogoSimplifiedChineseEng;
